import { useRecordingSettingsStore } from "@/store/recordingSettings.store";
import {
  AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS,
  AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS,
} from "@/common/config";
import {
  TranscriptionNoRealtimeProviderName,
  TranscriptionProviderName,
} from "@/hooks/transcriber/types";
import type { TranscriptionProviderOption } from "@/common/types/types";

export const useSelectTranscriptionProvider = (): {
  value: string;
  values: TranscriptionProviderOption[];
  handleChange: (value: string) => void;
} => {
  const {
    transcriptionProvider,
    saveTranscriptionProvider,
    isRealtimeEnabled,
    transcriptionNoRealtimeProvider,
    saveTranscriptionNoRealtimeProvider,
  } = useRecordingSettingsStore();

  const handleChange = (value: string): void => {
    if (isRealtimeEnabled) {
      if (
        AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS.some((p) => p.value === value)
      ) {
        saveTranscriptionProvider(value as TranscriptionProviderName);
      } else {
        saveTranscriptionProvider(TranscriptionProviderName.OPENAI);
      }
    } else {
      if (
        AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS.some((p) => p.value === value)
      ) {
        saveTranscriptionNoRealtimeProvider(
          value as TranscriptionNoRealtimeProviderName
        );
      } else {
        saveTranscriptionNoRealtimeProvider(
          TranscriptionNoRealtimeProviderName.DEEPGRAM_NOVA_3_MEDICAL
        );
      }
    }
  };

  const values = isRealtimeEnabled
    ? AUDIO_TRANSCRIPTION_REALTIME_PROVIDERS
    : AUDIO_TRANSCRIPTION_NO_REALTIME_PROVIDERS;

  const value = isRealtimeEnabled
    ? transcriptionProvider
    : transcriptionNoRealtimeProvider;

  return {
    value,
    values,
    handleChange,
  };
};
